import { Sigma } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgSum = mkIcon(Sigma);